import React from 'react';
import styles from './layout.module.css';
import image1400West from './DYK_TFP_WestCanola_1400.png';
import image900West from './DYK_TFP_WestCanola__900.png';
import image600West from './DYK_TFP_WestCanola_Mobile_600.png';
import image1400East from './DYK_ExportsCanada_1400.png';
import image900East from './DYK_ExportsCanada_900.png';
import image600East from './DYK_ExportsCanada_600.png';
import CONSTANTS from '../../../../constants/constants'


const Callout=(props)=>{ 
	const urlEast = ''
	const urlWest = ''

	const imageWest = {
		L: image1400West,
		M: image900West,
		S: image600West
	}
	const imageEast = {
		L: image1400East,
		M: image900East,
		S: image600East
	}

	const isWest = window.global.content_hub.region===CONSTANTS.WEST

	return (
		<React.Fragment>
			<div className={styles.container}>
				<a href={null} target="_blank" rel="noreferrer">
					<img className={styles.image1400} src={isWest?imageWest.L:imageEast.L} alt="callout"/>
					<img className={styles.image900} src={isWest?imageWest.M:imageEast.M} alt="callout"/>
					<img className={styles.image600} src={isWest?imageWest.S:imageEast.S} alt="callout"/>
				</a>
			</div>
		</React.Fragment>
	);
}

export default Callout;
